import app from 'firebase/compat/app'
import 'firebase/compat/auth'
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth'
import 'firebase/compat/analytics'
import 'firebase/compat/firestore'
import 'firebase/compat/database'

const config = {
    apiKey: "AIzaSyDOX_d7GZqSMd6EYrTOE_ckdICIS1m8fOE",
    authDomain: "eduardsala.firebaseapp.com",
    serverKey: "AAAAEDDsid4:APA91bHBwEi6FD0RFxsw5cmKY4mLQ5HpvniF7__2lQKzaJnNbWRoSudsllDduInOxVoQqeovyYSQxcF0ZAYi2007Ug_kUgG-rf5rN66HqdElkvx5ahEKDWebvctVoeg7ItjpHbAztu63",
    projectId: "the-sala-app",
    storageBucket: "the-sala-app.appspot.com",
    appId: "1:69540284894:web:389b757debcbb333cdb54f",
    measurementId: "G-R85LXTQK0T"
}
const provider = new GoogleAuthProvider();

class Firebase {
    constructor() {
        app.initializeApp(config)
        this.analytics = app.analytics()
        this.auth = app.auth()
        this.db = app.firestore()
        this.fireb = app.firestore
        this.database = app.database()
    }
    isInitialized() {
        return new Promise(resolve => {
            this.auth.onIdTokenChanged(resolve)
        })
    }

    login(email, password) {
        return this.auth.signInWithEmailAndPassword(email, password)
    }
    logout() {
        return this.auth.signOut()
    }
    async signInGoogle(setUser) {
        if (this.auth.currentUser) {
          // Sign out if the user is already signed in
          await signOut(this.auth);
          setUser(null);
        } else {
          // Sign in with Google if no user is signed in
          const result = await signInWithPopup(this.auth, provider);
          setUser(result.user);
          window.location.href = "/dash";
        }
      };
    async register(email, password) {
        await this.auth.createUserWithEmailAndPassword(email, password)
        return this.auth.currentUser.updateProfile({
            displayName: email
        })
    }
    addNewUserDb() {
        if (!this.auth.currentUser) {
            return alert('Not authorized')
        } else {
            this.db.doc(`ed-website/metadata-${this.auth.currentUser.email.substring(0, 3)}`).set({
                Savings: 1000,
                Pension: 10,
                "Portfolio Initial Capital": 1,
                "Withdrawal Rate": 4,
                "Yearly Expenses": 300,
                "Yearly Net Income": 1000,
                "Total Invested": 0,
                "Past Profits": 0,
                portfolioValue: 0,
            });
            this.db.doc(`ed-website/stocks-${this.auth.currentUser.email.substring(0, 3)}`).set({
                "GOOG": {
                    numStocks: 1,
                    openValue: 1000,
                    ticker: "GOOG",
                }
            });
            setTimeout(() => {window.location.href = "/dash"}, 2200)
        }
    }

    isTheUser() {
        return (this.auth.currentUser) ? true : false;
    }

}
export default new Firebase()